import React, { lazy, Suspense } from 'react';
import LoadingIndicator from '@wix/da-ds/pkg/LoadingIndicator';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import { useIsMounted } from '@wix/da-hooks/pkg/useIsMounted';
import useI18next from '../../hooks/useI18next';
import retry from '@wix/da-shared-react/pkg/utils/webpack/chunkRetry';

const LoadableStore = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "muro_editor" */
        './MuroEditorStore'
      )
  )
);

const LoadableModals = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "muro_editor" */
        '../Modals'
      )
  )
);

const I18NextLoader = () => {
  useI18next();
  return null;
};

interface Props {
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

/**
 * This is a wrapper that should be used in your preset
 */
const MuroEditorLoadableWrapper: React.FC<Props> = ({ children, fallback }) => {
  const isMounted = useIsMounted();

  if (!isMounted) {
    return null; // never SSR
  }

  return (
    <ErrorBoundary debugComponent="MuroEditorLoadableWrapper">
      <Suspense fallback={fallback ?? <LoadingIndicator view={'llama'} />}>
        <LoadableStore>
          <I18NextLoader />
          <LoadableModals />
          {children}
        </LoadableStore>
      </Suspense>
    </ErrorBoundary>
  );
};
MuroEditorLoadableWrapper.displayName = 'MuroEditorLoadableWrapper';

export default MuroEditorLoadableWrapper;
